module.exports = "<lui-overlay seedelement>\n  <div class=\"lui-modal__wrapper\">\n    <div class=\"lui-modal__content\">\n      <div class=\"lui-modal__content-title\">\n        <slot name=\"title\"></slot>\n        <lui-clear></lui-clear>\n      </div>\n      <div class=\"lui-modal__content-main\">\n        <slot></slot>\n      </div>\n      <div class=\"lui-modal__content-controls\">\n        <slot name=\"controls\"></slot>\n      </div>\n    </div>\n  </div>\n</lui-overlay>\n\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-modal/theme/lui-modal.html
// module id = 273
// module chunks = 0 1 31